import React, { useEffect, useState } from 'react'
import { Row, Col, Tabs, Card, Tooltip, Button, Table, Dropdown, Menu, Collapse, Modal, Form } from 'antd'

const { Panel } = Collapse;

import { connect } from 'react-redux'


import './index.scss'
import { Link, useHistory, useLocation } from "react-router-dom";
import { Account, getAccounts, getRequisitePDFfile } from "../../../../services/account";
import { Spinner } from "constants/constants";
import SearchableColumn from "components/Table/ColumnSearch";
import {
    AccountDetailsIco,
    AccountExtractIco,
    AccountMoreIco,
    BusinessCardIco,
    NewTransferIco,
    NoMoneyIco,
    TransfersIco,
    ArrowUpIco,
    ArrowDownIco,
    DovriyyeIcon,
    ModalCloseIco,
    PdfIco,
    SmsIco,
    BlockAccountIco
} from "../../../../../modules/CustomIcons";
import CustomTooltip from "components/Tooltip";
import Icon, { InfoCircleOutlined } from "@ant-design/icons";
import { getCurrentCompany } from "../../../../services/user";
import { dateFormatter, dateFormatterForBlock, financial } from "../../../../services/helper";
import SelectField from "components/SelectField";
import { getBlockedIbanData, getAccountsData, setMoreDetail, setIbanNumber, getRequisiteData } from '../../../../store/actions/accountStatement';
import { useActions } from 'hooks/useActions';
import { updateAccountNickname } from "../../../../services/Accounts/AccountNickname";
import NextModal from 'components/NextModalAccount';
import { getAccountType } from "../../../../services/Transfers/GetCustomerByIban";
import { checkAnyPermission } from "../../../../services/permission";
import { useTranslation } from 'react-i18next';



const circulationObj = {
    LAST_DAY_BALANCE: 0,
    DEBIT_BALANCE: 0,
    CREDIT_BALANCE: 0,
    BALANCE: 0,
};

const executedObj = {
    BALANCE: 0,
    WFA_AMOUNT: 0,
    WFA_DEBIT: 0,
    WFA_CREDIT: 0,
    WFA_COMMISSION: 0,
    LAST_BALANCE: 0
};

const Accounts: React.FC<any> = ({ companyData, blocksByIban, accountsData, inProgressAccounts, moreDetailData, requisiteData }) => {
    const {t} = useTranslation()


    const [ibanRef,setIbanRef]= useState()
    const [tableData, setTableData] = useState<Array<any>>([]);
    const [filteredData, setFilteredData] = useState<Array<any>>([])
    const [isFiltered, setIsFiltered] = useState(false)
    const [tableLoading, setTableLoading] = useState(Spinner);
    const [rowModalVisible, setRowModalVisible] = useState(false);
    const [currencyList, setCurrencyList] = useState([]);
    const [requisiteModalVisible, setRequisiteModalVisible] = useState(false);
    const [executionModalVisible, setExecutionModalVisible] = useState(false);
    const [activeExpRow, setActiveExpRow] = useState<Array<any>>([]);
    const [circulation, setCirculation] = useState(circulationObj);
    const [form] = Form.useForm();
    const [accountKey, setAccountKey] = useState("");
    const [isBlocked, setIsBlocked] = useState((moreDetailData && moreDetailData.key && moreDetailData.iban && moreDetailData.from === "moreButton") ? "1" : "");
    const [rowCurrency, setRowCurrency] = useState('');
    const [executed, setExecuted] = useState(executedObj);
    const [isVisibleDropdown, setIsVisibleDropdown] = useState(false);
    const [data,setData]= useState()
    const [titleRequisiteState, setTitleRequisiteState] = useState<Array<any>>([]);

    const { getBlockedIbanData, getAccountsData, setMoreDetail, setIbanNumber, getRequisiteData } = useActions();
    useEffect(()=>{
        let data
        if(requisiteData?.rekvizitAzn){
            data=requisiteData?.rekvizitAzn
            setData(data)
        }else if(requisiteData?.rekvizitUsd){
            data=requisiteData?.rekvizitUsd
            setData(data)
        }else if(requisiteData?.rekvizitEur){
            data=requisiteData?.rekvizitEur
            setData(data)
        }else if(requisiteData?.rekvizitGbp){
            data=requisiteData?.rekvizitGbp
            setData(data)
        }else if(requisiteData?.rekvizitJpy){
            data=requisiteData?.rekvizitJpy
            setData(data)
        }else if(requisiteData?.rekvizitChf){
            data=requisiteData?.rekvizitChf
            setData(data)
        }else if(requisiteData?.rekvizitRub){
            data=requisiteData?.rekvizitRub
            setData(data)
        }else if(requisiteData?.rekvizitCny){
            data=requisiteData?.rekvizitCny
            setData(data)
        }else if(requisiteData?.rekvizitTry){
            data=requisiteData?.rekvizitTry
            setData(data)
        }else if(requisiteData?.rekvizitInr){
            data=requisiteData?.rekvizitInr
            setData(data)
        }
    },[requisiteData])
    const currencyFilter = [
        {
            label: t("common.all"),
            value: 'all',
        },
        {
            label: 'AZN',
            value: 'AZN',
        },
        {
            label: 'USD',
            value: 'USD',
        },
        {
            label: 'RUB',
            value: 'RUB',
        },
        {
            label: 'EUR',
            value: 'EUR',
        },
        {
            label: 'GBP',
            value: 'GBP',
        },
    ]

    const updateAccountName = (e: any, row: any) => {
        let value = e.target.value.trim();
        let check_value = value.length > 0 ? value : '' /*getAccountType(row.ACCOUNT_TYPE)*/;

        const requestData = {
            IBAN: row.subtitle,
            NICKNAME: check_value
        }

        setTableLoading({
            ...tableLoading,
            spinning: true
        });

        updateAccountNickname(requestData).then(res => {
            getAccountsData({ company: getCurrentCompany() })
        })

    }

    const openExecutedModal = (row: any) => {

        setRowCurrency(old_data => row.CCY_NAME);

        setExecuted(old_data => {
            return {
                BALANCE: row.BALANCE ?? 0,
                WFA_AMOUNT: row.WFA_AMOUNT ?? 0,
                WFA_DEBIT: row.WFA_DEBIT ?? 0,
                WFA_CREDIT: row.WFA_CREDIT ?? 0,
                WFA_COMMISSION: row.WFA_COMMISSION ?? 0,
                LAST_BALANCE: row.LAST_BALANCE ?? 0
            }
        })

        setExecutionModalVisible(true)
    }

    const DropDownVisibleChange = (visible: boolean, record: any) => {
        const newData = [...tableData];
        newData.map((item: any) => {
            if (item.key === record.key) {
                item.isDropdown = !item.isDropdown
            } else {
                item.isDropdown = false;
            }
        })
        setTableData(newData)

        if (visible) {
            setCirculation(old_data => {
                return {
                    LAST_DAY_BALANCE: record.rowData.LAST_DAY_BALANCE,
                    DEBIT_BALANCE: record.rowData.DEBIT_BALANCE,
                    CREDIT_BALANCE: record.rowData.CREDIT_BALANCE,
                    BALANCE: record.rowData.BALANCE,
                }
            });
        }
        setIbanNumber({ iban: record["col_1"]["subtitle"] })
    }

    const [filtereValues, setFilteredValues] = useState({ "col_1": "", "col_2": "" })

    const handleFilterColumn = (e: any, column: string) => {

        let newfiltereValues = filtereValues;

        if (column === 'nickName') {
            newfiltereValues.col_1 = e.target.value?.toLowerCase()
            setFilteredValues(newfiltereValues)
        }

        if (column === 'CCY_NAME') {
            newfiltereValues.col_2 = e?.toLowerCase()
            setFilteredValues(newfiltereValues)
        }


        if (tableData && filtereValues) {
            let filteredData;
            filteredData = tableData?.filter(sRow => sRow.col_1.title.toLowerCase().normalize().replace(/[\u0300-\u036f]/g, '').includes(filtereValues["col_1"]) && sRow.col_2.toLowerCase().includes(filtereValues["col_2"]));

            setFilteredData(filteredData)
            setIsFiltered(true)

            if (filtereValues["col_2"] === 'all') {
                form.resetFields(['status_filter'])
            }
        }
    }

    const tableColumns = [
        {
            title: (
                <>
                    <div className="accountStatement_search-column">
                        <Form
                            form={form}
                        >
                            <SearchableColumn
                                form={form}
                                name={"nickname"}
                                filter={"searchfilter"}
                                title={t("home.accountNameNumber")}
                                onChange={(event: any) => handleFilterColumn(event, 'nickName')}
                            />
                        </Form>
                    </div>
                </>
            ),
            dataIndex: 'col_1',
            key: 'col_1',
            className: 'col_1 ant-table-cell-ellipsis',
              render: (data: any,alldata:any) => (
                <>
                    <p className=' align_center not_open_popup flex' >
                        <div className={'not_open_popup account_edit_nickname account_statement_searchable '} >
                            {/* <SearchableColumn
                                large
                                title={data.title}
                                customIcon={true}
                            /> */}
                            <Form
                                form={form}
                            >
                                <SearchableColumn
                                    large
                                    title={data.title.split('').length > 27 ? <CustomTooltip title={data.title}>{data.title}</CustomTooltip> : data.title}
                                    customIcon={true}
                                    form={form}
                                    nickname={alldata.nickName}
                                    value={data.title}
                                    allowClear={true}
                                    name={'updateAccountName'}
                                    /*onChange={(e) => updateAccountName(e, data.subtitle)}*/
                                    onBlur={(e) => updateAccountName(e, data)}
                                />
                                 
                            </Form>
                            
                        </div>
                        <div>{
                                                  alldata.rowData.STATUS === "0" ?
                                                    <CustomTooltip
                                                      title={t("transfers.closedAccount")}
                                                    >
                                                      <Button type={'ghost'} className={'transparent'} icon={<BlockAccountIco className='is_red' />} />
                                                    </CustomTooltip>
                                                    : <></>
                                                }</div>
                    </p>
                    <CustomTooltip title={data.tooltip} className={'iban_tooltip'} >
                        <span>
                            {data.subtitle}
                            {
                                data.has_cart && <Button icon={<BusinessCardIco />} className='transparent account_card_icon' />
                            }
                        </span>
                    </CustomTooltip>
                </>
            ),
            onCell: (record: any, index: number) => {
                return {
                    onClick: () => {
                        const newtableData: any = [...tableData];
                        newtableData[index]["isExpandable"] = true;
                        setTableData(newtableData);
                    },
                };
            },
        },
        {
            title: (
                <div>
                    <Form
                        form={form}
                    >
                        <SelectField
                            placeholder={t("home.currency")}
                            options={currencyFilter}
                            className="status-select"
                            onChange={(value: string) => handleFilterColumn(value, 'CCY_NAME')}
                            name={'status_filter'}
                        />
                    </Form>
                </div>
            ),
            dataIndex: 'col_2',
            key: 'col_2',
            className: 'col_2 ant-table-cell-ellipsis',
            render: (data: any) => (
                <>
                    <p className='has_balance'>{data}</p>
                </>
            ),
            onCell: (record: any, index: number) => {
                return {
                    onClick: () => {
                        const newtableData: any = [...tableData];
                        newtableData[index]["isExpandable"] = false;
                        setTableData(newtableData);
                    },
                };
            },
        },
        {
            title: t("home.balance"),
            dataIndex: 'col_3',
            key: 'col_3',
            className: 'col_3 ant-table-cell-ellipsis account-td-3',
            render: (data: any) => (
                <>
                    <p className={parseFloat(data) > 0 ? 'has_balance' : 'no_balance'}>{data}</p>
                </>
            ),
            onCell: (record: any, index: number) => {
                return {
                    onClick: () => {
                        const newtableData: any = [...tableData];
                        newtableData[index]["isExpandable"] = false;
                        setTableData(newtableData);
                    },
                };
            },
        },
        {
            title: t("home.blocked"),
            dataIndex: 'col_4',
            key: 'col_4',
            className: 'columnHasInfoIco col_4 ant-table-cell-ellipsis account-td-4',
            render: (data: any) => {

                let p_classname = parseFloat(data.title) > 0 ? 'has_blocked_amount' : 'no_blocked_amount';
                let tooltip_content = (parseFloat(data.title) > 0) ? `<p class="flex direction_column align_center flex_wrap">${t("home.restrictionsOnAccount")}. <Button type='button' class="ant-btn blue-button next_btn btn flex align_center justify_center fit_width acc_block_more_btn" >${t("ads.more")}</Button></p>` : data.title;

                return (
                    <>
                        <p className={`flex align_center justify_end ${p_classname}`}>{data.title}

                            {parseFloat(data.title) > 0 &&
                                <CustomTooltip title={tooltip_content}>
                                    <Button className='has_blocked_data has_blocked_data_1 transparent account-td-icon' icon={<InfoCircleOutlined />} />
                                </CustomTooltip>
                            }
                        </p>
                    </>
                )
            },
            onCell: (record: any, index: number) => {
                return {
                    onClick: () => {
                        const newtableData: any = [...tableData];
                        newtableData[index]["isExpandable"] = false;
                        setTableData(newtableData);
                    },
                };
            },
        },
        {
            title: t("home.availableBalance"),
            dataIndex: 'col_5',
            key: 'col_5',
            className: 'columnFreeBalance col_5 ant-table-cell-ellipsis account-td-5',
            render: (data: any) => {
                let p_classname = ' no_residue_amount ';

                if (parseFloat(data) < 0) {
                    p_classname = ' has_minus_residue_amount'

                } else if (parseFloat(data) > 0) {
                    p_classname = 'has_plus_residue_amount';
                }

                return (
                    <>
                        <p className={` ${p_classname}`}>{data}</p>
                    </>
                )
            },
            onCell: (record: any, index: number) => {
                return {
                    onClick: () => {
                        const newtableData: any = [...tableData];
                        newtableData[index]["isExpandable"] = false;
                        setTableData(newtableData);
                    },
                };
            },
        },
        {
            title: t("home.executionOnBank"),
            dataIndex: 'col_6',
            key: 'col_6',
            className: 'columnExecutedInBank col_6 ant-table-cell-ellipsis account-td-6',
            render: (data: any, record: any) => {

                let tooltip_content = (parseFloat(data.title) !== 0) ? `<p class="flex direction_column align_center flex_wrap">${t("home.transfersOnExecutionOnAccount")} <Button type='button' class="ant-btn blue-button next_btn btn flex align_center justify_center fit_width acc_block_more_btn" >${t("ads.more")}</Button></p>` : data.title;

                return (
                    <>
                        <p className={` ${data?.data?.className} account_page_bank_amount`}>{data.title}
                            {parseFloat(data.title) !== 0 &&
                                <CustomTooltip title={tooltip_content} onClick={(e) => openExecutedModal(record.rowData)} >
                                    <Button className='has_blocked_data transparent account-td-icon' icon={<InfoCircleOutlined />} />
                                </CustomTooltip>
                            }
                        </p>
                        {/* <p className={` ${data?.data?.className}`}>{data.title}
                            {parseFloat(data.title) !== 0 &&
                                <CustomTooltip title={data.title}>
                                    <Button className='has_blocked_data transparent account-td-icon' onClick={(e) => openExecutedModal(record.rowData)} icon={<InfoCircleOutlined />} />
                                </CustomTooltip>
                            }
                        </p> */}
                    </>
                )
            },
            onCell: (record: any, index: number) => {
                return {
                    onClick: () => {
                        const newtableData: any = [...tableData];
                        newtableData[index]["isExpandable"] = true;
                        setTableData(newtableData);
                    },
                };
            },
        },
        {
            title: t("home.afterExecution"),
            dataIndex: 'col_7',
            key: 'col_7',
            className: 'column7 col_7 ant-table-cell-ellipsis account-td-7',
            render: (data: any) => {

                let p_classname = '';

                if (parseFloat(data) > 0) {
                    p_classname = ' after_run_amount'

                }

                return (
                    <>
                        <p className={`flex align_center justify_end ${p_classname}`}>
                            {
                                parseFloat(data) < 0 ? <CustomTooltip title={t("home.insufficientFunds")} ><Button icon={<NoMoneyIco />} className='transparent' /></CustomTooltip> : data
                            }
                        </p>
                    </>
                )
            },
            onCell: (record: any, index: number) => {
                return {
                    onClick: (data: any) => {
                        const newtableData: any = [...tableData];
                        newtableData[index]["isExpandable"] = false;
                        setTableData(newtableData);
                    },
                };
            },
        },
        {
            title: '',
            key: 'action',
            fixed: "right",
            className: 'account_action_col col_88 ant-table-cell-ellipsis table-threeIcon',
            render: (record: any) => (
                <Dropdown overlay={tableDropDown(record)} trigger={['click']} visible={record.isDropdown} placement="bottomRight" onVisibleChange={(e) => DropDownVisibleChange(e, record)} >
                    <Button icon={<AccountMoreIco />} className='transparent table_more_btn ' />
                </Dropdown>
            ),
            onCell: (record: any, index: number) => {
                return {
                    onClick: () => {
                        const newtableData: any = [...tableData];
                        newtableData[index]["isExpandable"] = true;
                        setTableData(newtableData);
                    },
                };
            },
        },
        {
            title: "",
            dataIndex: "",
            key: "x",
            className: "table-expanededIcon expicontable",
            render: (record: any) => {
                return (
                    record.key === accountKey ?
                        <div>
                            <ArrowUpIco className={'cursor_pointer'} />
                        </div> :
                        <div>
                            <ArrowDownIco className={'cursor_pointer'} />
                        </div>
                )
            },
            onCell: (record: any, index: number) => {
                return {
                    onClick: () => {
                        const newtableData: any = [...tableData];
                        newtableData[index]["isExpandable"] = false;
                        setTableData(newtableData);
                    },
                };
            },
        },
    ];

    // const fetchData = async () => {
    //     setTableLoading({
    //         ...tableLoading,
    //         spinning: true
    //     });

    //     const data = await getAccounts(getCurrentCompany());

    //     let temp_array = [];

    //     for (let row of data) {

    //         let tooltip_content = `${row.BRANCH_NAME}-da olan ${row.PRODUCT_NAME}`;
    //         tooltip_content += `<br/>Yeni IBAN: ${row.IBAN}`;
    //         tooltip_content += `<br/>Köhnə IBAN: ${row.ORJ_IBAN ?? '-'}`;

    //         let col_6_class_name = '';

    //         if (parseFloat(row.WFA_AMOUNT) > 0) {
    //             col_6_class_name = 'is_blue';

    //         } else if (parseFloat(row.WFA_AMOUNT) < 0) {

    //             col_6_class_name = 'is_red';
    //         }

    //         // @ts-ignore
    //         temp_array.push({
    //             key: row.ACCOUNT_NO,
    //             col_1: { title: row.NICKNAME ? row.NICKNAME : row.PRODUCT_NAME, subtitle: row.IBAN, tooltip: tooltip_content, has_cart: row.COMPASSACCOUNT },
    //             col_2: row.CCY_NAME,
    //             col_3: financial(row.BALANCE),
    //             col_4: { title: financial(row.BLOCKSAMOUNT), data: [] },
    //             col_5: financial(row.REAL_BALANCE),
    //             col_6: { title: financial(row.WFA_AMOUNT), data: { className: col_6_class_name } },
    //             col_7: financial(row.LAST_BALANCE),
    //             branch_name: row.BRANCH_NAME
    //         });
    //     }


    //     setTableData(temp_array);
    //     setTableLoading({
    //         ...tableLoading,
    //         spinning: false
    //     });

    // };


    useEffect(() => {
        // if(accountsData?.length === 0)
            getAccountsData({ company: getCurrentCompany() })
    }, []);

    useEffect(() => {
        setTableLoading({
            ...tableLoading,
            spinning: inProgressAccounts
        });

        // const data = await getAccounts(getCurrentCompany());

        let temp_array = [];
        for (let row of accountsData) {

            let tooltip_content = `${row.BRANCH_NAME}-da olan ${row.NICKNAME ? row.NICKNAME : getAccountType(row.ACCOUNT_TYPE)}`;
            tooltip_content += `<br/>Yeni IBAN: ${row.IBAN}`;
            tooltip_content += `<br/>Köhnə IBAN: ${row.ORJ_IBAN ?? '-'}`;

            let col_6_class_name = '';

            if (parseFloat(row.WFA_AMOUNT) > 0) {
                col_6_class_name = 'is_blue';

            } else if (parseFloat(row.WFA_AMOUNT) < 0) {

                col_6_class_name = 'is_red';
            }

            // @ts-ignore
            temp_array.push({
                key: row.ACCOUNT_NO,
                col_1: { title: row.NICKNAME ? row.NICKNAME : getAccountType(row.ACCOUNT_TYPE), subtitle: row.IBAN, tooltip: tooltip_content, has_cart: row.COMPASSACCOUNT },
                col_2: row.CCY_NAME,
                col_3: financial(row.BALANCE),
                col_4: { title: financial(row.BLOCKSAMOUNT), data: [] },
                col_5: financial(row.REAL_BALANCE),
                col_6: { title: financial(row.WFA_AMOUNT), data: { className: col_6_class_name } },
                col_7: financial(row.LAST_BALANCE),
                branch_name: row.BRANCH_NAME,
                rowData: row,
                nickName: row.NICKNAME,
                isExpandable: false,
                isDropdown: false
            });
        }


        setTableData(temp_array);
        // setTableLoading({
        //     ...tableLoading,
        //     spinning: false
        // });

    }, [accountsData, inProgressAccounts]);

    const rowClassName = (record: any, index: number) => {
        return index % 2 ? 'table-row-light' : 'table-row-dark'
    }

    const openRequisite = (record: any) => {
        const titleRequisite = [
            // record.col_1.title,
            // record.col_3,
            // record.col_2
        ]
        setIbanRef(record.col_1.subtitle)
        setTitleRequisiteState(titleRequisite);
        getRequisiteData({ company: getCurrentCompany(), ibanRef: record.col_1.subtitle })
        setRequisiteModalVisible(old_data => true);
    }

    const tableDropDown = (record: any) => {
        return (
            <Menu className='hesablar_dropdown account-three-dot-dropdown'>
                <Menu.Item icon={<Icon component={() => (<DovriyyeIcon className={'dovriyye_icon'} />)} />}>
                    <Link onClick={(e) => { setRowModalVisible(old_data => true); controlDropdownMenu(); return false }} to={'#'} >{t("home.turnover")}</Link>
                </Menu.Item>
                {
                    checkAnyPermission(['OWN_ACCOUNT', 'INTERNAL', 'EXCHANGE', 'AZIPS', 'XOHKS', 'DXA', 'EDV', 'SWIFT', 'SWIFT_RUB', 'TEMPLATE']) &&
                    <Menu.Item icon={<Icon component={() => (<NewTransferIco />)} />}>
                        <Link to={'/new_transfer/'} >{t("home.newTransfer")}</Link>
                    </Menu.Item>
                }
                {
                    checkAnyPermission(['AZIPS', 'SWIFT', 'XOHKS', 'BATCH_PAYMENT', 'EXCHANGE', 'INTERNAL', 'OWN_ACCOUNT', 'DXA', 'IPS_OTH', 'IPS_BDG', 'IPS_VAT', 'EDV', 'SWIFT_RUB', 'TEMPLATE', 'SALARY_TOTAL']) &&
                    <Menu.Item icon={<Icon component={() => (<TransfersIco />)} />}>
                        <Link to={'/transfers/ALL'} >{t("home.transfers")}</Link>
                    </Menu.Item>
                }
                <Menu.Item icon={<Icon component={() => (<AccountExtractIco />)} />}>
                    <Link to={'/accounts/account_statement'} >{t("home.statement")}</Link>
                </Menu.Item>

                {/* <Menu.Item icon={<Icon component={() => (<InfoCircleOutlined className='teslifatlar_ico' />)} />}>
                <Link to={'/'} >{t("home.details")}</Link>
            </Menu.Item> */}

                <Menu.Item icon={<Icon component={() => (<AccountDetailsIco />)} />}>
                    <Link onClick={(e) => { openRequisite(record); controlDropdownMenu(); return false }} to={'#'}  >{t("requisites.accountDetails")}</Link>
                </Menu.Item>
            </Menu>
        )
    }

    const onExpandFunc = (expanded: boolean, record: any) => {
        const keys = [];
        if (!record.isExpandable) {
            if (expanded) {
                getBlockedIbanData({ company: getCurrentCompany(), ibanRef: record.col_1.subtitle });
                keys.push(record.key);
                setAccountKey(record.key);
            } else {
                setAccountKey("")
            }
            setActiveExpRow(keys);
        }

    }

    const expandedRowRenderFunc = (record: any) =>
        <div className='expandableRow__container'>
            <div>
                <div className='expandableRow__container--title'>
                    {t("accounts.accountDetails")}
                </div>
                <div className='expandableRow__container--value'>
                    <span className='expandableRow__container--value-span1'>{t("accounts.branch")}</span>
                    <span className='expandableRow__container--value-span2'>{record.branch_name}</span>
                </div>
            </div>
            {
                blocksByIban.length !== 0 ?
                    <div>
                        <Collapse
                            defaultActiveKey={[isBlocked]}
                            className='expandableRow__collapse'
                            expandIconPosition="end"
                            ghost={true}
                            expandIcon={({ isActive }) => <ArrowUpIco className={isActive ? "blockIconUp" : "blockIconDown"} />}
                        >
                            <Panel header={t("accounts.blockings")} key="1">
                                <div className='expandableRow__panel'>
                                    {
                                        blocksByIban ? blocksByIban.map((item: any, i: number) => {

                                            return (
                                                <div className='expandableRow__panel--grids' key={i}>
                                                    <div className='expandableRow__panel--grids-item'>
                                                        <div className='expandableRow__panel--grids-itemTitle'>
                                                            {t("accounts.blockedNumber")}
                                                        </div>
                                                        <div className='expandableRow__panel--grids-itemValue'>
                                                            {item.blockId}
                                                        </div>
                                                    </div>
                                                    <div className='expandableRow__panel--grids-item'>
                                                        <div className='expandableRow__panel--grids-itemTitle'>
                                                            {t("accounts.blockedAmount")}
                                                        </div>
                                                        <div className='expandableRow__panel--grids-itemValue'>
                                                            {financial(item.blockAmount)}
                                                        </div>
                                                    </div>
                                                    <div className='expandableRow__panel--grids-item'>
                                                        <div className='expandableRow__panel--grids-itemTitle'>
                                                            {t("accounts.blockedDate")}
                                                        </div>
                                                        <div className='expandableRow__panel--grids-itemValue'>
                                                            {dateFormatterForBlock(item.blockDate, "YYYY-MM-DD")}
                                                        </div>
                                                    </div>
                                                    <div className='expandableRow__panel--grids-item'>
                                                        <div className='expandableRow__panel--grids-itemTitle'>
                                                            {t("accounts.blockedReason")}
                                                        </div>
                                                        <div className='expandableRow__panel--grids-itemValue'>
                                                            {item.description}
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }) : <></>
                                    }
                                </div>
                            </Panel>
                        </Collapse>
                    </div> : <></>
            }

        </div>

    const showMoreDetailByScroll = () => {

        if (moreDetailData && moreDetailData.key && moreDetailData.iban) {
            setTimeout(() => {
                const data: any = document.getElementsByClassName("ant-table-row");
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let item = data[i];

                        var cashKey = accountsData?.find(row1 => row1.IBAN === moreDetailData.iban);

                        if (item.getAttribute("data-row-key") === (cashKey !== undefined ? cashKey.ACCOUNT_NO : moreDetailData.key)) {
                            setActiveExpRow([(cashKey !== undefined ? cashKey.ACCOUNT_NO : moreDetailData.key)]);
                            getBlockedIbanData({ company: getCurrentCompany(), ibanRef: moreDetailData.iban });
                            setAccountKey((cashKey !== undefined ? cashKey.ACCOUNT_NO : moreDetailData.key));
                            item.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" })
                            setMoreDetail({ key: "", iban: "", from: "" })
                        }
                    }
                }
            }, 100)
        }
    }

    useEffect(() => {

        if(accountsData !== undefined && accountsData?.length > 0)
            showMoreDetailByScroll()
    }, [accountsData])

    const controlDropdownMenu = () => {
        const newData = [...tableData];
        newData.map((item: any) => {
            item.isDropdown = false
        })
        setTableData(newData)
    };

    useEffect(() => {
        const layoutScroll = document.getElementById("layout_scroll");
        if (typeof layoutScroll !== 'undefined') {
            layoutScroll?.addEventListener('scroll', controlDropdownMenu);

            return () => {
                layoutScroll?.removeEventListener('scroll', controlDropdownMenu);
            };
        }
    });

    const modalDataRequisite = () => {
        return requisiteData?.rekvizitAzn && requisiteData?.rekvizitAzn[0]?.ccyType === "AZN" ? {
            modalTitle: `${t("requisites.accountDetails")}: ${titleRequisiteState[0] ?? ''} ${titleRequisiteState[1] ?? ''} ${titleRequisiteState[2] ?? ''}`,
            groups: [
                {
                    title: t("requisites.bankAccountDetails"),
                    tableHasBorderBottom: false,
                    data: [
                        {
                            label: t("requisites.customer"),
                            value: requisiteData?.customerName ?? ''
                        },
                        {
                            label: t("requisites.legalAddress"),
                            value: requisiteData?.customerAddress ?? ''
                        },
                        {
                            label: t("requisites.customerBank"),
                            value: requisiteData?.bankName ?? ''
                        },
                        {
                            label: t("requisites.taxID"),
                            value: requisiteData?.bankVoen ?? ''
                        },
                        {
                            label: t("requisites.legalAddress"),
                            value: requisiteData?.bankAddress ?? ''
                        },
                        {
                            label: t("requisites.phone"),
                            value: requisiteData?.bankPhone ?? ''
                        },
                        {
                            label: t("requisites.email"),
                            value: requisiteData?.bankEmail ?? ''
                        },
                    ],
                },
                {
                    title: t("requisites.beneficiary"),
                    tableHasBorderBottom: false,
                    tableHasMarginBottom: true,
                    currency: titleRequisiteState[2] ?? '',
                    data: [
                        {
                            label: t("requisites.name"),
                            value: data ? data[0]?.customerName : '',
                        },
                        {
                            label: t("requisites.taxID"),
                            value: data ? data[0]?.customerVoen : '',
                        },
                        {
                            label: 'IBAN',
                            value: data ? data[0]?.iban : '',
                        }
                    ],
                },
                {
                    title: t("requisites.beneficiaryBank"),
                    tableHasBorderBottom: false,
                    tableHasMarginBottom: true,
                    data: [
                        {
                            label: t("requisites.name"),
                            value: data ? data[0]?.bankName : '',
                        },
                        {
                            label: t("requisites.code"),
                            value: data ? data[0]?.bankCode : '',
                        },
                        {
                            label: t("requisites.mH"),
                            value: data ? data[0]?.bankAccount : '',
                        },
                        {
                            label: 'SWIFT',
                            value: data ? data[0]?.bankSwift : '',
                        },
                    ],
                }
            ],
                buttons: [
                    { selectAccount: true }
                ],
            } :
            {
                modalTitle: `${t("requisites.accountDetails")}: ${titleRequisiteState[0] ?? ''} ${titleRequisiteState[1] ?? ''} ${titleRequisiteState[2] ?? ''}`,
                groups: [
                    {
                        title: t("requisites.bankAccountDetails"),
                        tableHasBorderBottom: false,
                        data: [
                            {
                                label: t("requisites.customer"),
                                value: requisiteData?.customerName ?? ''
                            },
                            {
                                label: t("requisites.legalAddress"),
                                value: requisiteData?.customerAddress ?? ''
                            },
                            {
                                label: t("requisites.customerBank"),
                                value: requisiteData?.bankName ?? ''
                            },
                            {
                                label: t("requisites.taxID"),
                                value: requisiteData?.bankVoen ?? ''
                            },
                            {
                                label: t("requisites.legalAddress"),
                                value: requisiteData?.bankAddress ?? ''
                            },
                            {
                                label: t("requisites.phone"),
                                value: requisiteData?.bankPhone ?? ''
                            },
                            {
                                label: t("requisites.email"),
                                value: requisiteData?.bankEmail ?? ''
                            },
                        ],
                    },
                    {
                        title: t("requisites.beneficiary"),
                        tableHasBorderBottom: false,
                        tableHasMarginBottom: true,
                        currency: titleRequisiteState[2] ?? '',
                        data: [
                            {
                                label: t("requisites.name"),
                                value: data ? data[0]?.customerName : '',
                            },
                            {
                                label: t("requisites.taxID"),
                                value: data ? data[0]?.customerVoen : '',
                            },
                            {
                                label: 'IBAN',
                                value: data ? data[0]?.iban : '',
                            }
                        ],
                    },
                    {
                        title: t("requisites.beneficiaryBank"),
                        tableHasBorderBottom: false,
                        tableHasMarginBottom: true,
                        data: [
                            {
                                label: t("requisites.name"),
                                value: data ? data[0]?.bankName : '',
                            },
                            {
                                label: t("transfers.address"),
                                value: data ? data[0]?.bankAddress : '',
                            },
                            {
                                label: 'SWIFT',
                                value: data ? data[0]?.bankSwift : '',
                            },
                        ],
                    },
                    {
                        title: t("newTransfer.intermediaryBank"),
                        tableHasBorderBottom: false,
                        tableHasMarginBottom: true,
                        data: [
                            {
                                label: t("requisites.name"),
                                value: data ? data[0]?.muhbirName : '',
                            },
                            {
                                label: t("transfers.address"),
                                value: data ? data[0]?.muhbirAddress : '',
                            },
                            {
                                label: 'SWIFT',
                                value: data ? data[0]?.muhbirSwift : '',
                            },
                        ],
                    }
                ],
                buttons: [
                    { selectAccount: true }
                ],
            }
    }

    const handleModalClose = () => {
        setRequisiteModalVisible(false)
    }

    const [exportDetail, setExportDetail] = useState<any>([false, false]);

    const exportRequisitePDF = async (value) => {
        let newExportDedatil = [...exportDetail];
        newExportDedatil[0] = true;
        setExportDetail(newExportDedatil)

        const formData = {
            ibanRef: ibanRef
        }
        const data = await getRequisitePDFfile(formData,value)
        downloadPDF(data?.data.fileDetailsList[0].fileName, data?.data.fileDetailsList[0].fileBase64);

        newExportDedatil = [...exportDetail];
        newExportDedatil[0] = false;
        setExportDetail(newExportDedatil)
    }

    function downloadPDF(fileName: string, fileBase64: string) {
        const linkSource = `data:application/pdf;base64,${fileBase64}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }

    const sendFunc = () => {
        // console.log("export1")
    }

    const footerBtnsSecondModal = [
        {
            icon: <PdfIco />,
            title: '',
            key: 'pdf',
            loading: exportDetail[0],
            onClickFunc: exportRequisitePDF,
            disabled: false,
        },
        {
            icon: <SmsIco />,
            title: '',
            key: 'sms',
            loading: exportDetail[1],
            onClickFunc: sendFunc,
            disabled: true,
        },
    ]


    return (
        <>
            <Row className={'cur_exchange_bg'}>
                <Col flex={'700px'} className="own-account">
                    <Card bordered={false}>
                        <Row justify='start' className="own-account__form">

                            <Table
                                pagination={false}
                                loading={tableLoading}
                                columns={tableColumns}
                                dataSource={isFiltered == true ? filteredData : tableData}
                                rowClassName={rowClassName}
                                className='table-striped table-hover table table-responsive home_content_table home_account_table accounts_page_table'
                                scroll={{ x: true }}
                                expandable={{
                                    expandedRowClassName: () => "expandableRow",
                                    expandedRowRender: expandedRowRenderFunc,
                                    expandedRowKeys: activeExpRow,
                                    onExpand: onExpandFunc,
                                    expandRowByClick: true,
                                    expandIconColumnIndex: -1,
                                    showExpandColumn: false
                                }}
                            // onRow={(record, rowIndex) => {
                            //     return {
                            //         onClick: e => {

                            //             // let status =
                            //             //     e?.target?.classList?.contains('not_open_popup') ||
                            //             //         e?.target?.classList?.contains('ant-table-column-title') ||
                            //             //         e?.target?.classList?.contains('ant-btn') ||
                            //             //         e?.target?.classList?.contains('anticon') ||
                            //             //         e?.target?.tagName == 'button' ||
                            //             //         e?.target?.tagName == 'svg' ||
                            //             //         e?.target?.tagName == 'path'
                            //             //         ? false : true;

                            //             // setRowModalVisible(status);
                            //         },
                            //     };
                            // }}
                            />

                        </Row>
                    </Card>
                </Col>
            </Row>

            <Modal
                title={t("home.executionOnBank")}
                closeIcon={<ModalCloseIco />}
                centered
                visible={executionModalVisible}
                onOk={() => setExecutionModalVisible(false)}
                onCancel={() => setExecutionModalVisible(false)}
                width={460}
                className={'manage_faster_menus requisite_modal form_next_modal'}
                keyboard={false}
                focusTriggerAfterClose={false}
                footer={false}
            >

                <ul className='full flex direction_column box_list'>
                    <li className={'no_border'} >
                        <div className={'full flex justify_between'} >
                            <p>{t("home.availableBalance")}</p>
                            <p>{financial(executed.BALANCE)} {rowCurrency}</p>
                        </div>

                        <div className={'full flex justify_center second_title '} >
                            <p>{t("home.paymentOrdersOnExecutionAtBank")}</p>
                        </div>
                    </li>

                    <li>
                        <p>{t("home.credit")}</p>
                        <p className={'is_blue'} >{financial(executed.WFA_CREDIT)} {rowCurrency}</p>
                    </li>

                    <li>
                        <p>{t("home.debit")}</p>
                        <p className={'is_red'} >{financial(executed.WFA_DEBIT)} {rowCurrency}</p>
                    </li>

                    <li>
                        <p>{t("home.commission")}</p>
                        <p className={'is_red'} >{financial(executed.WFA_COMMISSION)} {rowCurrency}</p>
                    </li>

                    <li>
                        <p>{t("home.balanceAfterExecution")}</p>
                        <p>
                            {
                                (financial(executed.LAST_BALANCE) < 0) ?
                                    <CustomTooltip title={t("home.insufficientFunds")} ><Button icon={<NoMoneyIco />} className='transparent' /></CustomTooltip> : `${financial(executed.LAST_BALANCE)} ${rowCurrency}`

                            }
                            {/* {financial(executed.LAST_BALANCE)} {rowCurrency}Kifayət qədər <br/> vəsait mövcud deyil */}
                        </p>
                    </li>
                </ul>

            </Modal>

            <Modal
                title={t("home.turnoverForCurrentBankingDay")}
                closeIcon={<ModalCloseIco />}
                centered
                visible={rowModalVisible}
                onOk={() => setRowModalVisible(false)}
                onCancel={() => setRowModalVisible(false)}
                width={460}
                className={'manage_faster_menus requisite_modal form_next_modal'}
                keyboard={false}
                focusTriggerAfterClose={false}
                footer={false}
            >

                <ul className='full flex direction_column box_list'>

                    <li>
                        <p>{t("home.startingBalance")}</p>
                        <p>{financial(circulation.LAST_DAY_BALANCE)}</p>
                    </li>

                    <li>
                        <p>{t("home.debit")}</p>
                        <p className={'is_red'} >{financial(circulation.DEBIT_BALANCE)}</p>
                    </li>

                    <li>
                        <p>{t("home.credit")}</p>
                        <p className={'is_blue'} >{financial(circulation.CREDIT_BALANCE)}</p>
                    </li>

                    <li>
                        <p>{t("home.balance")}</p>
                        <p>{financial(circulation.BALANCE)}</p>
                    </li>
                </ul>

            </Modal>

            <NextModal
                // btnType={'APPROVE'}
                // requestType={requestType}
                // disabledSign={props.disabledSign}
                // onStatusChange={props.handleStatusChange}
                // nextModalText={'Köçürmələr qrupu banka göndərilir. Nəticəni “Köçürmələr”də izləyə bilərsiniz.'}
                // callBackApi={newTransferFunc}
                visible={requisiteModalVisible}
                data={modalDataRequisite()}
                // // tableTitle ={props.type == 'common' ? '' : t("transfers.transferHistory") }
                // columnsData={columnsData}
                // tableData={props.tableData['SIGN_DETAIL']}
                // type={props.type}
                onClose={handleModalClose}
                // innerColumnsdata={innerColumnsdata}
                // innerrtableData={props.innerrtableData}
                // transferData={props.type == 'common' ? false : true}
                className={'flex_middle'}
                source={'requiste'}
                otherButtons={footerBtnsSecondModal}
            />
        </>
    )
}


const mapDispatchToProps = { getBlockedIbanData, getAccountsData, setMoreDetail, setIbanNumber, getRequisiteData }

const mapStateToProps = (state: any) => ({
    companyData: (state.user && state.user.companyData.result) ? state.user.companyData.result.customerNo : getCurrentCompany(),
    blocksByIban: state.accountsStatement.blocksByIban.result ?? [],
    accountsData: state.accountsStatement.accountsData ?? [],
    inProgressAccounts: state.accountsStatement.inProgressAccounts,
    moreDetailData: (state.accountsStatement && state.accountsStatement.moreDetailData) ? state.accountsStatement.moreDetailData : {},
    requisiteData: state.accountsStatement.requisiteData.result ?? []
})

export default connect(mapStateToProps, mapDispatchToProps)(Accounts)
